var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-card",
    { staticClass: "warnings-list", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        [
          _vm.alertsList.length === 0
            ? _c(
                "div",
                { staticClass: "text-center" },
                [
                  _c(
                    "v-icon",
                    { attrs: { color: "grey lighten-1", size: "64" } },
                    [_vm._v("mdi-alert-circle-outline")]
                  ),
                  _c("div", { staticClass: "text-subtitle-1" }, [
                    _vm._v("No warnings to display"),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._l(_vm.alertsList, function (alert) {
            return [
              _c(
                "v-alert",
                {
                  key: alert.id,
                  attrs: {
                    text: "",
                    outlined: "",
                    type: _vm.getAlertType(alert.alertType),
                    color: _vm.getAlertColor(alert.alertType),
                    icon: "mdi-fire",
                  },
                },
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { staticClass: "grow" }, [
                        _c("div", [
                          _vm._v(" " + _vm._s(alert.alertMessage) + " "),
                        ]),
                        _c("div", [
                          _vm._v(
                            "Alert Time: " +
                              _vm._s(
                                _vm.$helpers.formatDate(
                                  alert.created,
                                  "MM-dd-yyyy hh:mm:ss"
                                )
                              )
                          ),
                        ]),
                      ]),
                      _c(
                        "v-col",
                        { staticClass: "shrink" },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { "x-small": "" },
                              on: {
                                click: function ($event) {
                                  return _vm.resolveAlert(alert)
                                },
                              },
                            },
                            [_vm._v("Resolve")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }